import React, { useCallback } from 'react';
import { BreadCrumb, BreadCrumbContent, BredCrumbBlock, BreadSlash, Icon } from '../styles';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../../global/constants';
import { BreadcrumbPathItemProps } from '../../../../interfaces/ProjectInterface';
import { RawProjectFile } from '../../../../mobx/interfaces/project';

interface FilesBreadcrumbProps {
  path: RawProjectFile[];
  onClickFilesText: () => void;
  onClickFile: (item: RawProjectFile) => void;
}

const BreadcrumbPathItem = React.memo<BreadcrumbPathItemProps>(({ item, index, pathLength, onClickFile }) => {
  const handleClick = useCallback(() => {
    onClickFile(item);
  }, [onClickFile, item]);

  return (
    <React.Fragment>
      <BreadSlash>/</BreadSlash>
      <BredCrumbBlock role='button' isActive={index === pathLength - 1} onClick={handleClick}>
        {item?.name}
      </BredCrumbBlock>
    </React.Fragment>
  );
});

BreadcrumbPathItem.displayName = 'BreadcrumbPathItem';

const FilesBreadcrumb: React.FC<FilesBreadcrumbProps> = ({ path, onClickFilesText, onClickFile }) => {
  return (
    <BreadCrumb>
      <Icon>
        <SVGIcon
          name='filepath-folder-icon'
          width={ICON_SIZE.XXL}
          height={ICON_SIZE.XXL}
          viewBox={`0 0 ${ICON_SIZE.XXL} ${ICON_SIZE.XXL}`}
        />
      </Icon>
      <BreadCrumbContent>
        <BredCrumbBlock role='button' onClick={onClickFilesText}>
          Files
        </BredCrumbBlock>
        {path
          ?.slice(0)
          ?.reverse()
          ?.map((item, index: number) => (
            <BreadcrumbPathItem
              key={item?.id}
              item={item}
              index={index}
              pathLength={path?.length}
              onClickFile={onClickFile}
            />
          ))}
      </BreadCrumbContent>
    </BreadCrumb>
  );
};

export default FilesBreadcrumb;
